import { useEffect, useState } from 'react';

import { createRoot } from 'react-dom/client';
import '../assets/css/drawer.css';
import '../assets/css/styles.css';
import separador from '../assets/img/separador.png';
import header from '../assets/img/casas.png';
import Drawer from '../components/drawer.jsx'
import Dialog from '../components/dialog2.jsx'
import _Dialog from '../components/dialog.jsx'
import { getCopa } from '../funciones/sesion.js'
import { casaIc } from '../funciones/casas.js'
import { clubMensaje, copaMensaje } from '../funciones/generales.js'
import { typeWriter } from '../funciones/typeWriter';
import Mapa from '../components/mapa.jsx'


function Carta(props) {
    useEffect(() => {
        /*const elements = document.getElementsByClassName('element');
        elements[3].classList.add("active")*/
    }, []);
    return (
        <div className="Sesion">
            <header>

            </header>

            
            <div id="dg"></div>
            <div class="container-">
                <Mapa></Mapa>
            </div>



        </div>);
}

export default Carta;